@if (conditionForm) {
  <form [formGroup]="conditionForm" class="grid grid-cols-3 gap-3">
    <div>
      <p-treeselect
        class="w-full md:w-80"
        [formControl]="selectedFilterControl"
        [options]="productFiltersTree()"
        [filter]="true"
        (onNodeSelect)="onFilterNodeSelect($event)"
        [appendTo]="appendTo()"
      >
        <ng-template let-node pTemplate="value">
          <span class="flex items-center">
            <mat-icon class="tree-node-icon">{{ selectedKeyIcon() }}</mat-icon>

            {{
              selectedFilter()?.key
                ? ('COLUMN_' + selectedFilter()?.key?.toUpperCase() | translate)
                : ''
            }}
          </span>
        </ng-template>
        <ng-template let-node pTemplate="default">
          <span class="flex items-center">
            @if (node.emIcon) {
              <mat-icon class="tree-node-icon">{{ node.emIcon }}</mat-icon>
            }
            @if (node.imageUrl) {
              <img
                class="w-6 h-6 mr-2"
                [src]="node.imageUrl"
                [alt]="node.label"
              />
            }

            {{ node.label | translate }}
          </span>
        </ng-template>
      </p-treeselect>
    </div>

    @if (selectedFilter(); as selectedFilter) {
      @if (selectedFilter.isCustom) {
        @switch (selectedFilter.key) {
          @case ('category') {
            <em-select
              formControlName="excludeProducts"
              [subscriptSizing]="'dynamic'"
            >
              <em-option [value]="false">{{
                'MARKET_INSIGHTS_INCLUDE_SELECTED' | translate
              }}</em-option>
              <em-option [value]="true">{{
                'MARKET_INSIGHTS_EXCLUDE_SELECTED' | translate
              }}</em-option>
            </em-select>

            <em-category-selection
              class="overflow-hidden"
              formControlName="categories"
              [appendTo]="appendTo()"
            >
            </em-category-selection>
          }
          @case ('custom_labels') {
            <em-custom-labels-condition
              [formGroup]="conditionForm"
              [operatorType]="'string'"
              [isNullable]="selectedFilter.isNullable"
              class="col-span-2"
            ></em-custom-labels-condition>
          }
          @case ('best_price') {
            <em-best-price-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-best-price-filter>
          }
          @case ('mode_price_v2') {
            <em-most-used-price-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-most-used-price-filter>
          }
          @case ('price_changes') {
            <em-price-changes-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-price-changes-filter>
          }
          @case ('fetch_status') {
            <em-fetch-status-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-fetch-status-filter>
          }
          @case ('outliers') {
            <em-outliers-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-outliers-filter>
          }
          @case ('uploaded_since') {
            <em-days-value-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-days-value-filter>
          }
          @case ('source_created_at') {
            <em-days-value-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-days-value-filter>
          }
          @case ('with_competitors') {
            <em-with-competitors-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-with-competitors-filter>
          }
          @case ('product_performance') {
            <em-product-performance-filter
              [formGroup]="conditionForm"
              class="col-span-2"
            ></em-product-performance-filter>
          }
        }
      } @else {
        <em-product-group-condition
          [formGroup]="conditionForm"
          [operatorType]="selectedFilter.operatorType"
          [isNullable]="selectedFilter.isNullable"
          class="col-span-2"
        >
        </em-product-group-condition>
      }
    }
  </form>
}
